export enum ViewportSize {
    mobile = 599, // 0 - 599
    mobileLandscape = 767, // 600 - 767
    tablet = 1024, // 768 - 1024
    desktop = 1599, // 1025 - 1599 // 1600+ - large desktop
}

export const media = {
    mobile: `@media (max-width: ${ViewportSize.mobile}px)`,
    mobileLandscape: `@media (max-width: ${ViewportSize.mobileLandscape}px)`,
    mobileLandscapeOnly: `@media (min-width: ${ViewportSize.mobile+1}px) and (max-width: ${ViewportSize.mobileLandscape}px)`,
    mobileAndTablet: `@media (max-width: ${ViewportSize.tablet}px)`,
    tablet: `@media (min-width: ${ViewportSize.mobileLandscape+1}px)`,
    tabletOnly: `@media (min-width: ${ViewportSize.mobileLandscape+1}px) and (max-width: ${ViewportSize.tablet}px)`,
    desktop : `@media (min-width: ${ViewportSize.tablet+1}px)`,
    desktopLarge: `@media (min-width: ${ViewportSize.desktop+1}px)`
};
